import { render, staticRenderFns } from "./TaxPicker.vue?vue&type=template&id=5d3b140d"
import script from "./TaxPicker.vue?vue&type=script&lang=js"
export * from "./TaxPicker.vue?vue&type=script&lang=js"
import style0 from "./TaxPicker.vue?vue&type=style&index=0&id=5d3b140d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports